/* eslint-disable react/prop-types */
import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import SmallLoading from '../../element/SmallLoading';
// mui
import Tooltip from '@mui/material/Tooltip';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NoteAddRoundedIcon from '@mui/icons-material/NoteAddRounded';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import { GoogleAnalyticsService } from 'core/services/GoogleAnalyticsService';
const ApplyJobSelectForm = ({
  jobId,
  setStep,
  onlyResume,
  isSubmitting,
  subscribeAlert,
  setIsSubmitting,
  checkUserFormData,
  setJobApplyResult,
  onlyQuestionnaire,
  setSubscribeAlert,
}) => {
  const { t } = useTranslation('global');
  const tokenKey = Cookies.get('tokenClient');

  const [file, setFile] = useState(null);
  const [isOpened, setIsOpened] = useState(false);
  const [coverLetter, setCoverLetter] = useState('');
  const [errors, setErrors] = useState({ file: '' });
  const [activeFilesList, setActiveFilesList] = useState([]);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [activeResumesList, setActiveResumesList] = useState([]);
  const [selectedResumeId, setSelectedResumeId] = useState(null);

  const getActiveResumes = async () => {
    try {
      const response = await axios.get(
        BaseApi + '/candidates/getActiveCvList',
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      setActiveResumesList(response.data.response);
    } catch (error) {
      console.error('Error at applied button at job description');
    }
  };

  const getActiveFiles = async () => {
    try {
      const response = await axios.get(
        BaseApi + '/jobApply/getFileList',
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            contentType: 'application/json',
          },
        },
      );

      setActiveFilesList(response.data.response.filesList);
    } catch (error) {
      console.error('Error at applied button at job description');
    }
  };

  const handleFileChange = file => {
    GoogleAnalyticsService.trackEvent(
          'job_apply-upload-file',
           {
            message: t('jobDescription.applyError'),
            status: 'ERROR'
           }
        )
    const allowedTypes = [
      'text/plain',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];

    if (file && file.size <= 5 * 1024 * 1024 && allowedTypes.includes(file.type)) {
      setFile(file);
      setSelectedFileId(null);
      setSelectedResumeId(null);
GoogleAnalyticsService.trackEvent(
          'job_apply-upload-file',
           {
            message: "File uploaded successfully",
            status: 'SUCCESS'
           }
        )
      setErrors(prev => ({
        ...prev,
        file: '',
      }));
    } else {
      setFile(null);
      setSelectedFileId(null);
      setSelectedResumeId(null);

      setErrors(prev => ({
        ...prev,
        file: t('jobDescription.fileError'),
      }));
      GoogleAnalyticsService.trackEvent(
          'job_apply-upload-file',
           {
            message: t('jobDescription.fileError'),
            status: 'ERROR'
           }
        )
    }
  };

  const handleFileDrop = e => {
    e.preventDefault();

    const file = e.dataTransfer.files[0];

    handleFileChange(file);
  };

  const handleCoverLetterChange = e => {
    const value = e.target.value;

    if (value.length <= 500) {
      setCoverLetter(value);
    }
  };

  const handleFileDownload = async (e, id) => {
    e.preventDefault();

    try {
      const response = await axios.get(
        BaseApi + `/jobApply/downloadFile/${id}`,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
          },
          responseType: 'blob',
        },
      );

      const url = window.URL.createObjectURL(response.data);
      const filename = response.headers['content-disposition'].split('filename=')[1];

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename.replace(/['"]/g, ''));
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Could not download file:', error);

      Swal.fire({
        icon: 'error',
        confirmButtonText: t('employerInnerAccountdetail.close'),
        title: t('employerFavouriteListProfile.fileDownloadFailedTitle'),
      });
    }
  };

  const handleResumeSubmit = async e => {
    e.preventDefault();
 GoogleAnalyticsService.trackEvent(
          'job_apply',
           {
            message: "Resume start submit",
            status: "INFO"
           }
        )
    try {
      setIsSubmitting(true);

      const formData = new FormData();

      file && formData.append('file', file);
      jobId && formData.append('idJob', jobId);
      coverLetter && formData.append('message', coverLetter);
      selectedFileId && formData.append('fileId', selectedFileId);
      selectedResumeId && formData.append('idCv', selectedResumeId);
      subscribeAlert && formData.append('subscribeAlert', subscribeAlert);
      checkUserFormData.contact && formData.append('contact', checkUserFormData.contact);
      checkUserFormData.last_name && formData.append('last_name', checkUserFormData.last_name);
      checkUserFormData.first_name && formData.append('first_name', checkUserFormData.first_name);
      checkUserFormData.email_address && formData.append('email_address', checkUserFormData.email_address);

      const response = await axios.post(
        BaseApi + '/jobApply/sentJobApply',
        formData,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
          },
        },
      );

      if (response.data.status === 200) {
        setStep('jobApplyResult');
        setJobApplyResult(prev => ({
          ...prev,
          result: 'success',
          message: t('jobDescription.jobAppliedSuccess'),
        }));
        GoogleAnalyticsService.trackEvent(
          'job_apply',
           {
            message: response.data.message,
            status: 'SUCCESS'
           }
        )
      } else if (response.data.status === 500) {
        setStep('jobApplyResult');
        setJobApplyResult(prev => ({
          ...prev,
          result: 'warning',
          message: t('jobDescription.jobAlreadyApplied'),
          
        }));
         GoogleAnalyticsService.trackEvent(
          'job_apply',
           {
            message: t('jobDescription.jobAlreadyApplied'),
            status: 'WARNING'
           }
        )
      } else {
        setStep('jobApplyResult');
        setJobApplyResult(prev => ({
          ...prev,
          result: 'error',
          message: t('jobDescription.applyError'),
        }));
          GoogleAnalyticsService.trackEvent(
          'job_apply',
           {
            message: t('jobDescription.applyError'),
            status: 'ERROR'
           }
        )
      }

      setIsSubmitting(false);
    }
    catch (error) {
      setIsSubmitting(false);
  GoogleAnalyticsService.trackEvent(
          'job_apply',
           {
            message: t('jobDescription.applyError'),
            status: 'ERROR'
           }
        )
      const Toast = Swal.mixin({
        toast: true,
        timer: 5000,
        position: 'top-end',
        timerProgressBar: true,
        showConfirmButton: false,
        didOpen: toast => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: 'error',
        title: t('jobDescription.applyError'),
      });
    }
  };

  useEffect(() => {
    getActiveFiles();
    getActiveResumes();
  }
  , []); // eslint-disable-line

  return(
    <form className='applyJobSelectForm' onSubmit={handleResumeSubmit}>
      {
        onlyQuestionnaire && !onlyResume
          ? (
            setStep('questionnaire')
          ) : (
            <div>
              {
                !!onlyResume && (
                  <div>
                    <div className='selectBox'>
                      <button type='button' className='selectBoxHeader' onClick={() => setIsOpened(!isOpened)}>
                        <div className='d-flex align-items-center'>
                          <InsertDriveFileRoundedIcon sx={{ mr: '8px', fontSize: '25px', color: '#294A9C' }} />
                          {t('jobDescription.selectResume')}
                        </div>
                        {
                          isOpened
                            ? <ExpandLessIcon sx={{ fontSize: '25px', color: '#294A9C' }} />
                            : <ExpandMoreIcon sx={{ fontSize: '25px', color: '#294A9C' }} />
                        }
                      </button>
                      {
                        isOpened && (
                          <div>
                            {
                              activeFilesList?.length === 0 && activeResumesList?.length === 0
                                ? (
                                  <div className='mt-2 text-center'>
                                    {t('jobDescription.noResumeAndFiles')}
                                  </div>
                                ) : (
                                  <div className='resumeBox'>
                                    {
                                      activeResumesList?.map(i => (
                                        <div
                                          key={i.id}
                                          className={`resumeItem APActionButton${selectedResumeId === i.id ? ' selected' : ''}`}
                                          onClick={() => {
                                            setSelectedResumeId(prevId => (prevId === i.id ? null : i.id));
                                            setFile(null);
                                            setSelectedFileId(null);
                                          }}
                                        >
                                          <div className='resumeLabelBox'>
                                            <label
                                              title={i.name}
                                              className='resumeLabel'
                                              onClick={e => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setSelectedResumeId(prevId => (prevId === i.id ? null : i.id));
                                                setFile(null);
                                                setSelectedFileId(null);
                                              }}
                                            >
                                              <input
                                                readOnly
                                                type='radio'
                                                value={i.id}
                                                name='resume'
                                                className='resumeRadio'
                                                checked={selectedResumeId === i.id}
                                              />
                                              {i.name}
                                            </label>
                                          </div>
                                          <Link target='_blank' className='btn-primary button1' to={`/candidates/my-cv-list/${i.id}`}>
                                            <Tooltip title={t('jobDescription.view')}>
                                              <VisibilityIcon />
                                            </Tooltip>
                                          </Link>
                                        </div>
                                      ))
                                    }
                                    {
                                      activeFilesList?.map(i => (
                                        <div
                                          key={i.id}
                                          className={`resumeItem APActionButton${selectedFileId === i.file_id ? ' selected' : ''}`}
                                          onClick={() => {
                                            setSelectedFileId(prevId => (prevId === i.file_id ? null : i.file_id));
                                            setFile(null);
                                            setSelectedResumeId(null);
                                          }}
                                        >
                                          <div className='resumeLabelBox'>
                                            <label
                                              title={i.file.name}
                                              className='resumeLabel'
                                              onClick={e => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setSelectedFileId(prevId => (prevId === i.file_id ? null : i.file_id));
                                                setFile(null);
                                                setSelectedResumeId(null);
                                              }}
                                            >
                                              <input
                                                readOnly
                                                name='file'
                                                type='radio'
                                                value={i.file_id}
                                                className='resumeRadio'
                                                checked={selectedFileId === i.file_id}
                                              />
                                              {i.file.name}
                                            </label>
                                          </div>
                                          <Link className='btn-primary button1' onClick={e => handleFileDownload(e, i.file_id)}>
                                            <Tooltip title={t('jobDescription.view')}>
                                              <FileDownloadOutlinedIcon />
                                            </Tooltip>
                                          </Link>
                                        </div>
                                      ))
                                    }
                                  </div>
                                )
                            }
                          </div>
                        )
                      }
                    </div>
                    <div className='selectBox'>
                      <button type='button' className='selectBoxHeader' onClick={() => setStep('createResume')}>
                        <div className='d-flex align-items-center'>
                          <NoteAddRoundedIcon sx={{ mr: '8px', fontSize: '25px', color: '#294A9C' }} />
                          {t('jobDescription.createResume')}
                        </div>
                      </button>
                    </div>
                    <div className='mb-3'>
                      <label className='coverLetterLabel' htmlFor='coverLetter'>{t('jobDescription.uploadResume')}</label>
                      <div className='fileUploadBox' onDrop={handleFileDrop} onDragOver={e => e.preventDefault()}>
                        <UploadFileRoundedIcon sx={{ mr: '8px', fontSize: '25px', color: '#294A9C' }} />
                        {
                          file
                            ? (
                              <div className='fileUploadItem'>
                                <div>
                                  <p className='fs-6 text-center'>{file.name}</p>
                                  <p className='text-center' style={{ color: '#36854D' }}>{t('jobDescription.fileUploadSuccess')}</p>
                                </div>
                                <div>
                                  <p className='fs-6 fw-bold text-center'>
                                    {t('jobDescription.fileUploadTxt1')}{' '}
                                    {t('jobDescription.fileUploadTxt2')}
                                    <label className='fileUploadLabel'>
                                      {t('jobDescription.fileUploadTxt4')}
                                      <input
                                        type='file'
                                        className='fileUploadInput'
                                        accept='.doc,.docx,.txt,.pdf'
                                        onChange={e => handleFileChange(e.target.files[0])}
                                      />
                                    </label>
                                  </p>
                                  <p className='text-muted'>Підтримуються файли doc, docx, txt, pdf до 5 МБ</p>
                                </div>
                              </div>
                            ) : (
                              <div className='fileUploadItem'>
                                <div>
                                  <p className='fs-6 fw-bold text-center'>{t('jobDescription.fileUploadTxt1')}</p>
                                  <p className='fs-6 fw-bold text-center'>
                                    {t('jobDescription.fileUploadTxt2')}
                                    <label className='fileUploadLabel'>
                                      {t('jobDescription.fileUploadTxt3')}
                                      <input
                                        type='file'
                                        className='fileUploadInput'
                                        accept='.doc,.docx,.txt,.pdf'
                                        onChange={e => handleFileChange(e.target.files[0])}
                                      />
                                    </label>
                                  </p>
                                </div>
                                <p className='text-muted text-center'>Підтримуються файли doc, docx, txt, pdf до 5 МБ</p>
                              </div>
                            )
                        }
                      </div>
                      {
                        errors.file && (
                          <div className='text-danger'>
                            {errors.file}
                          </div>
                        )
                      }
                    </div>
                  </div>
                )
              }
              {
                !!onlyResume && !!onlyQuestionnaire && (
                  <div className='selectBox'>
                    <button type='button' className='selectBoxHeader' onClick={() => setStep('questionnaire')}>
                      <div className='d-flex align-items-center'>
                        <DescriptionRoundedIcon sx={{ mr: '8px', fontSize: '25px', color: '#294A9C' }} />
                        {t('jobDescription.selectQustionnaire')}
                      </div>
                    </button>
                  </div>
                )
              }
              <div className='coverLetterBox'>
                <label className='coverLetterLabel' htmlFor='coverLetter'>{t('jobDescription.coverLetter')}</label>
                <textarea
                  rows={5}
                  maxLength='500'
                  id='coverLetter'
                  value={coverLetter}
                  className='form-control'
                  onChange={handleCoverLetterChange}
                  placeholder={t('jobDescription.coverLetterPlaceholder')}
                />
                <small className='coverLetterCount text-muted'>
                  {t('jobDescription.characterLimit')} {500 - coverLetter.length}
                </small>
              </div>
              <div className='subscribeAlertBox'>
                <label className='subscribeAlertLabel'>
                  <input
                    type='checkbox'
                    name='subscribeAlert'
                    checked={subscribeAlert}
                    className='me-2 subscribeAlertCheckbox'
                    onChange={() => setSubscribeAlert(prevState => !prevState)}
                  />
                  {t('jobDescription.subscribeAlert')}
                </label>
              </div>
              <div className='dataProcessingConsentBox'>
                <p>
                  {t('jobDescription.bottomTxt1')}{' '}
                  <Link to='/data-processing-consent'>
                    {t('jobDescription.bottomTxt2')}
                  </Link>
                </p>
              </div>
              <div className='d-flex justify-content-evenly'>
                <button
                  type='submit'
                  className='mt-0 btn button1'
                  onClick={handleResumeSubmit}
                  disabled={isSubmitting || (!file && !selectedResumeId && !selectedFileId)}
                >
                  {t('jobDescription.applyNow')}{' '}
                  {isSubmitting && <SmallLoading width='24px' height='24px' color='#FFF' style={{ marginLeft: '8px' }} />}
                </button>
              </div>
            </div>
          )
      }
    </form>
  );
};

export default ApplyJobSelectForm;
